<template>
  <div
    class="c-announcement"
    v-if="banners"
    :class="{ 'is-single': banners.length == 1 }"
  >
    <div class="glide" :ref="`glide_${uid}`">
      <div class="glide__track" data-glide-el="track">
        <div class="glide__slides">
          <div
            v-for="(displayBanner, index) in banners"
            :key="index"
            class="glide__slide c-announcement__slide"
            :data-glide-autoplay="displayBanner.duration"
          >
            <image-loader :image-id="displayBanner.file_id" />

            <article>
              <div class="c-announcement__title">
                <h2>{{ displayBanner.title }}</h2>
              </div>

              <!-- <p>
                {{ displayBanner.description }}
              </p> -->
              <div class="c-announcement__buttons">
                <base-button @click="handleClick(index)" outline v-if="displayBanner.button_text">{{
                  displayBanner.button_text
                }}</base-button>
                <base-button
                  primary="true"
                  @click="toggleVideo(index)"
                  icon-after="arrow"
                  v-show="bannerHasVideo(index)"
                  >Watch Video
                </base-button>
              </div>
            </article>
          </div>
        </div>
      </div>

      <div
        data-glide-el="controls"
        class="c-announcement__controls"
        v-if="banners.length > 1"
      >
        <button data-glide-dir="<" aria-labelledby="label--prev">
          <svg
            width="17"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 7a1 1 0 1 1 0 2V7ZM.293 8.707a1 1 0 0 1 0-1.414L6.657.929A1 1 0 0 1 8.07 2.343L2.414 8l5.657 5.657a1 1 0 1 1-1.414 1.414L.293 8.707ZM16 9H1V7h15v2Z"
              fill="#fff"
            />
          </svg>
          <span class="screen-reader-text" id="label--prev"
            >Previous banner</span
          >
        </button>
        <button data-glide-dir=">" aria-labelledby="label--next">
          <svg
            width="17"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 7a1 1 0 0 0 0 2V7Zm15.707 1.707a1 1 0 0 0 0-1.414L10.343.929A1 1 0 1 0 8.93 2.343L14.586 8l-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM1 9h15V7H1v2Z"
              fill="#fff"
            /></svg
          ><span class="screen-reader-text" id="label--next">Next banner</span>
        </button>
      </div>
    </div>
    <modal-video
      :video-link="videoLink"
      v-if="showVideo"
      @close="showVideo = false"
    />
  </div>
</template>

<script>
import ImageLoader from '@/components/elements/ImageLoader.vue';
import ModalVideo from '@/components/ModalVideo.vue';
import filesApi from '@/api/files';
import Glide, {
  Autoplay,
  Swipe,
  Controls,
  Breakpoints,
  Images,
  Anchors,
} from '@glidejs/glide/dist/glide.modular.esm';

export default {
  name: 'AnnouncementWidget',
  components: { ImageLoader, ModalVideo },
  async mounted() {
    this.$emit('michael', 'announcement');
    this.loading = false;
    let resp;
    resp = await this.$store.dispatch('widgets/announcements/setBanner', {
      bannerId: this.banner,
    });
    this.banners = resp.banners;
    this.displayBanner = resp;
    this.loading = false;
    this.$nextTick(async () => {
      if (this.banners.length > 1) {
        const glide = new Glide(
          this.$refs[`glide_${this.uid}`],
          this.carouselSettings,
        );
        glide.on('swipe.end', () => {
          // this.updateButtons();
        });
        glide.on('build.after', () => {
          this.loaded = true;
        });
        glide.on('run.before', () => {
          if (this.$refs[`glide_${this.uid}`]) {
            this.$refs[`glide_${this.uid}`].classList.add('transition');
          }
        });
        glide.on('run.after', () => {
          if (this.$refs[`glide_${this.uid}`]) {
            this.$refs[`glide_${this.uid}`].classList.remove('transition');
          }
        });
        glide.mount({
          Autoplay,
          Swipe,
          Controls,
          Breakpoints,
          Images,
          Anchors,
        });

        this.glide = glide;
      }
    });
  },
  methods: {
    bannerHasVideo(index) {
      const displayBanner = this.banners[index];
      return (
        (displayBanner.video && displayBanner.video.link) ||
        (displayBanner.video_id && displayBanner.video_id.link) ||
        displayBanner.video_url
      );
    },
    async toggleVideo(index) {
      if (!this.bannerHasVideo(index)) return false;
      this.showVideo = !this.showVideo;
      const displayBanner = this.banners[index];
      if (displayBanner.video_url) {
        this.videoLink = displayBanner.video_url;
      } else {
        // need to get the video, put the link into the modal, display it
        const videoLink = displayBanner.video
          ? displayBanner.video.link
          : displayBanner.video_id.link;
        const data = await filesApi.readLink(videoLink);
        this.videoLink = URL.createObjectURL(data.data); // create a link rather then base64
      }
    },
    handleClick(index) {
      const displayBanner = this.banners[index];
      if (displayBanner.link_url) {
        return window.open(displayBanner.link_url);
      }
      console.log('Current Banner', displayBanner);
      console.log('Current Banner Set', this.banners);
      // if the resource is a document or policy
      if (displayBanner.resource_obj.current_version) {
        // eforms are different too
        if (displayBanner.resource_obj.self.includes('eformmanagement')) {
          // account for if url starts with a slash or not
          const url =
            displayBanner.resource_obj.eform_url.substr(0, 1) == '/'
              ? displayBanner.resource_obj.eform_url
              : `/${displayBanner.resource_obj.eform_url}`;
          return this.$router.push({
            path: `/forms${url}`,
          });
        }
        if (displayBanner.resource_obj.self.includes('survey')) {
          // account for if url starts with a slash or not
          const url =
            displayBanner.resource_obj.survey_url.substr(0, 1) == '/'
              ? displayBanner.resource_obj.survey_url
              : `/${displayBanner.resource_obj.survey_url}`;
          return this.$router.push({
            path: `/survey${url}`,
          });
        }
        const docId = displayBanner.resource_obj.id;
        const docType = displayBanner.resource_obj.self.includes('policy')
          ? 'policies'
          : 'forms';
        return this.$router.push({ path: `/documents/${docType}/${docId}` });
      }

      // if we are a file
      if (displayBanner.resource_obj.file_hash) {
        this.$store
          .dispatch('files/read', displayBanner.resource_obj.id)
          .then(resp => this.$store.dispatch('files/download', resp));

        return;
      }
      if (displayBanner.resource_obj.page_url) {
        // account for if url starts with a slash or not
        const url =
          displayBanner.resource_obj.page_url.substr(0, 1) == '/'
            ? displayBanner.resource_obj.page_url
            : `/${displayBanner.resource_obj.page_url}`;
        return this.$router.push({
          path: `/content${url}`,
        });
      }

      this.$router.push({ path: `/${displayBanner.resource_obj.self}` });
    },
  },

  data() {
    return {
      showVideo: false,
      heroImageSrc: null,
      loading: true,
      banners: null,
      videoLink: '',
      glide: {},
      uid: Math.random()
        .toString(36)
        .substring(7),
      carouselSettings: {
        type: 'slider',
        perView: 1,
        gap: 0,
        autoplay: 5000,
        hoverpause: true,
      },
    };
  },
  props: {
    banner: {
      type: [String, Number],
      default: null,
    },
  },

  watch: {
    async banner(newValue, oldValue) {
      const resp = await this.$store.dispatch('widgets/announcements/setBanner', {
        bannerId: newValue,
      });
      this.banners = resp.banners;
      this.displayBanner = resp;
      this.loading = false;
      this.$nextTick(async () => {
        if (this.banners.length > 1) {
          const glide = new Glide(
            this.$refs[`glide_${this.uid}`],
            this.carouselSettings,
          );
          glide.on('swipe.end', () => {
            // this.updateButtons();
          });
          glide.on('build.after', () => {
            this.loaded = true;
          });
          glide.on('run.before', () => {
            if (this.$refs[`glide_${this.uid}`]) {
              this.$refs[`glide_${this.uid}`].classList.add('transition');
            }
          });
          glide.on('run.after', () => {
            if (this.$refs[`glide_${this.uid}`]) {
              this.$refs[`glide_${this.uid}`].classList.remove('transition');
            }
          });
          glide.mount({
            Autoplay,
            Swipe,
            Controls,
            Breakpoints,
            Images,
            Anchors,
          });

          this.glide = glide;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "node_modules/@glidejs/glide/src/assets/sass/glide.core";
.c-announcement {
  display: flex;
  height: 100%;
  min-height: 350px;

  &.is-single {
    .glide__slides {
      display: block !important;
    }
  }

  &__controls {
    display: flex;
    gap: 10px;
    right: 0;
    padding: 7px;
    position: absolute;
    top: 224px;

    button {
      background: $colour-nhs-core-blue;
      cursor: pointer;
      border: none;
      padding: 7px;

      &:hover {
        background: $colour-nhs-bright-blue;
      }


    }
    @media (min-width: 768px) {
      top: 294px;
    }
  }

  .glide__track,
  .glide__slides {
    height: 100%;
  }

  &__slide {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-width: 100%;
    overflow: hidden;
    position: relative;
    min-height: 350px;

    article {
      bottom: 0;
      box-sizing: border-box;
      color: $colour-nhs-core-white;
      padding: 0;
      position: relative;
      width: 100%;
      z-index: 1;


       @media (min-width: 768px) {
        position: absolute;
       }
    }

    img {
      position: relative;
      height:263px;
      z-index: 1;
      @supports (object-fit: cover) {
        object-fit: cover;
      }
       @media (min-width: 768px) {
        height:350px;
       }
    }
  }
  &__buttons {
    background-color: #000000;
    padding:16px;
    button {
      height: 38px;
      padding: 0.5rem 1rem;
      @media (min-width: 1440px) {
        height: 52px;
        padding:1rem;
      }
    }
    @media (min-width: 768px) {
        padding-top:2px;
        background-color: transparent;
     }
  }
  &__title {
      background-color: $colour-nhs-core-blue;
      height:96px;
      position: relative;
      h2 {
        position: absolute;
        bottom:10px;
        font-size:16px;
        padding:5px 15px 7px 15px;
        margin-bottom: 0;
        margin-top:0;
        @media (min-width: 1440px) {
          font-size:24px;
        }
      }
      @media (min-width: 768px) {
        background-color: transparent;
      }
  }

  //Single Column
  &[css-class="12"] & {

    @media (min-width: 1440px) {

      &__controls {
         top: 276px;
         right:10px;

        button {
          @media (min-width: 1440px) {
            padding: 16px;
          }
        }
      }

    }

  }
  //2 Column
  //3 Column
  &[css-class="6"] &,
  &[css-class="4"] & {

    @media (min-width: 992px) {

      &__slide {
        article {
          position:relative;
        }
        img {
          height:100%;
        }
      }
      &__controls {
        top: auto;
        bottom:158px;
        padding-right:0;
      }
      &__buttons {
        background-color: #000000;
        padding:16px;
      }
      &__title {
        background-color: $colour-nhs-core-blue;
      }
    }
  }

  &[css-class="6"] & {

    @media (min-width: 1440px) {
      &__slide {
        article {
          position:absolute;
          bottom:0;
        }
        img {
          height:100%;
        }
      }
      &__controls {
        bottom: 9px;
        padding-right:15px;

        button {
            padding: 16px;
        }
      }
      &__buttons {
         background-color: transparent;
         padding-top:2px;
      }
      &__title {
        background-color: transparent;
        bottom:3px;
        h2 {
          font-size: 18px;
        }
      }
    }
  }

  &[css-class="4"] & {

    @media (min-width: 1024px) {


    }
    @media (min-width: 1440px) {
      &__controls {
        bottom:170px;

      }
      &__title {
        h2 {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.row.announcement {

      > .col-md-6 {
        &:first-child {
          margin-bottom: 40px;
        }
      }
      > .col-md-4 {
        &:first-child,
        &:nth-child(2) {
          margin-bottom: 40px;
        }
      }
    @media (min-width: 992px) {
      > .col-md-6 {
        &:first-child {
          margin-bottom: 0;
        }
      }
      > .col-md-4 {
        &:first-child,
        &:nth-child(2) {
          margin-bottom: 0;
        }
      }
    }
    @media (min-width: 992px) {


      > .col-md-4 {
        flex-basis: 50%;
        max-width: 50%;
        &:last-child {
          margin-top:40px;
        }
      }
    }
    @media (min-width: 1440px) {
      > .col-md-4 {
        flex-basis: 33.3333%;
        max-width: 33.3333%;
        &:last-child {
          margin-top:0;
        }
      }
    }
}
</style>
